import Data from '../../../../../components/Display/Data';
import { Button } from 'primereact/button';
import MultiLineData from '../../../../../components/Display/MultiLineData';
import styles from "../../../cards.module.scss"

function ReviewListItem({ review, deleteReview, updateReview }) {
  return (
    <div className={styles.reviewCard}>
      <div className={styles.content}>
        <div className={styles.top}>
          <Data key="author" label={'Auteur.e'} value={review.author} large />
          <Data key="company" label={'Projet'} value={review.company} large />
        </div>
        <MultiLineData
          key="description"
          label={'Description'}
          value={review.content}
          asHtml
          naturalWidth
        />
      </div>
      <div className="flex gap-2">
        <Button
          rounded
          icon="pi pi-pencil"
          severity="success"
          onClick={() => updateReview(review)}
          outlined
          size="small"
          className="!h-9 !w-9"
        />
        <Button
          rounded
          icon="pi pi-trash"
          severity="danger"
          onClick={() => deleteReview(review)}
          outlined
          size="small"
          className="!h-9 !w-9"
        />
      </div>
    </div>
  );
}

export default ReviewListItem;
